import { Component, Inject, Optional, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../service/login.service';
import { Router } from '@angular/router';
import { TokenService } from '../../../../shared/service/token.service';
import { AuthService } from '../../../../core/services/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { customPatternValidator, phoneNumberValidation } from '../../../../shared/custom-validator/pattern-validator';
import { SpinnerComponent } from '../../../../shared/component/spinner/spinner.component';
import { noWhitespaceValidator } from '../../../../shared/custom-validator/white-space-validator';
import { isPlatformBrowser } from '@angular/common';
import { UserLocationService } from 'src/app/shared/service/user-location.service';
import { SharedDataService } from 'src/app/shared/service/shared-data/shared-data.service';
import { UserOrgService } from 'src/app/shared/service/user-org.service';
import { passwordStrengthValidator } from 'src/app/shared/custom-validator/password-validator';
import { LOCAL_STORAGE_KEYS, ROLES_PERMISSIONS } from 'src/app/constants/roles-permissions.constants';
import { interval, Subscription } from 'rxjs';
import { CustomToastComponent } from 'src/app/shared/component/custom-toast/custom-toast.component';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { MatSelect } from '@angular/material/select';
import { ElementRef } from '@angular/core';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { OrganizationService } from '../../location/services/organization.service';
import { EnvironmentService } from 'src/app/shared/environment.service';
import { DepartmentService } from '../../location/services/department.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  @ViewChild('countryCodeSelect') countryCodeSelect!: MatSelect;
  @ViewChild('mobileInput') mobileInputElement!: ElementRef;
  @ViewChild('emailInput') emailInputElement!: ElementRef;
  mobPlaceHolder: string;
  isFocused: boolean = false;
  isMobileFieldTouched = false;
  loginForm: FormGroup;
  hide: boolean = true;
  passwordIncorrect: boolean = false;
  disableOtp: boolean = true;
  disableLogin: boolean = false;
  errorMessage: string = '';
  countdownSubscription: Subscription | null = null;
  loginAttempts: number = 0; // Track the number of failed attempts
  cooldownTime: number = 60; // Cooldown duration in seconds (1 minute)
  otpAttempt: number = 0
  otpCountdownSubscription: Subscription | null = null;
  countryCodes = [
    { dialCode: '+1' }, // US & Canada
    { dialCode: '+91' }, // India
    { dialCode: '+44' }, // United Kingdom
    { dialCode: '+61' }, // Australia
    { dialCode: '+33' }, // France
    { dialCode: '+49' }, // Germany
    { dialCode: '+27' }, // South Africa
    { dialCode: '+81' }, // Japan
    { dialCode: '+55' }, // Brazil
    { dialCode: '+52' }, // Mexico
    { dialCode: '+7' }, // Russia
    { dialCode: '+39' }, // Italy
    { dialCode: '+34' }, // Spain
    { dialCode: '+64' }, // New Zealand
    { dialCode: '+31' }, // Netherlands
    { dialCode: '+41' }, //Switzerland
    // Add other countries as needed
  ];
  emailUname: boolean = true; //is email or phone number
  showLogin: boolean = true;
  otpReqEmail: string;
  frgtPwdOtp:boolean = false
  changePwd:boolean = false
  showForgotPwd: boolean = false;
  constructor(
    private _formBuilder: FormBuilder,
    public loginService: LoginService,
    public router: Router,
    public tokenService: TokenService,
    public _auth: AuthService,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<LoginComponent> | null,
    @Inject(PLATFORM_ID) private platformId: Object,
    private sharedDataService: SharedDataService,
    private _locationService: UserLocationService,
    private userOrgService: UserOrgService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
    private permissionsService: PermissionsService,
    private orgService: OrganizationService,
    private envService: EnvironmentService,
    private _departmentService: DepartmentService
  ) {
    this.loginForm = this._formBuilder.group({
      email: [
        '',
        [Validators.required, customPatternValidator('email', 'email')],
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          noWhitespaceValidator(),
          passwordStrengthValidator(),
        ],
      ],
    });
    this.mobPlaceHolder = phoneNumberValidation(
      this.loginForm.value.countryCode
    );
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }
  ngOnInit() {
    this.checkCooldownOnInit();
    this.checkOtpCooldownInit()

  }
  checkCooldownOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const cooldownEnd = Number(localStorage.getItem('cooldownEnd')) || 0;
      this.loginAttempts = Number(localStorage.getItem('loginAttempts')) || 0;
      if (cooldownEnd > Date.now()) {
        this.disableLogin = true;
        this.startCooldownTimer(cooldownEnd);
      }
    }
  }

  checkOtpCooldownInit(){
    if (isPlatformBrowser(this.platformId)) {
      const otpCooldownEnd = Number(localStorage.getItem('otpCooldownEnd')) || 0;
      this.otpAttempt = Number(localStorage.getItem('otpAttempt')) || 0;
      if (otpCooldownEnd > Date.now()) {
        this.disableOtp = true;
        this.startOtpCooldownTimer(otpCooldownEnd);
      }
      else{
        if (this.loginForm.get('email')?.valid) {
          this.disableOtp = false;
        }
        localStorage.setItem('otpAttempt', '0'); // Reset login attempts
        this.otpAttempt = 0
      }
    }
  }

  updateOtpAttempt(event:any){
    if(event){
      this.handleOtpRequest()
    }
    else{
      localStorage.removeItem('otpAttempt');
      localStorage.removeItem('otpCooldownEnd');
    }
  }

  /** Form submit: Sign in button or Enter in the password field */
  onLoginSubmit(): void {
    if (this.loginForm.invalid || this.disableLogin) {
      this.loginForm.markAllAsTouched(); // show the validation messages instead of doing nothing
      return;
    }
    this.signIn();
  }

  signIn() {
    // Trim spaces
    const email = this.loginForm.get('email')?.value.trim();
    const password = this.loginForm.get('password')?.value.trim();
    this.loginForm.patchValue({ email, password });
    const addSpinnerRef = this.dialog.open(SpinnerComponent, {
      disableClose: true,
      panelClass: 'transparent-dialog',
    });
    let cooldownEnd = Number(localStorage.getItem('cooldownEnd')) || 0;

    // Prevent login if cooldown is active
    if (cooldownEnd > Date.now()) {
      const remainingTime = Math.ceil((cooldownEnd - Date.now()) / 1000);
      this.translate
        .get('login.invalid_login.COOLDOWN_MESSAGE', {
          time: `<span class="error-time">${this.formatTime(
            remainingTime
          )}</span>`,
        })
        .subscribe((translatedMessage: string) => {
          this.errorMessage = translatedMessage;
        });
      this.disableLogin = true;
      addSpinnerRef.close();
      return;
    }
    this.loginService.userLogin(this.loginForm.value).subscribe({
      next: (data: any) => {
        if (data.status === 200) {
          localStorage.removeItem('loginAttempts');
          localStorage.removeItem('cooldownEnd');
          if (data?.body) {
            this._locationService.setLocationData(data?.body?.locationIds);
            this._locationService.setSelLocationName(data?.body?.locationIds[0].locationName)
            this._departmentService.setbaseDeptId(data?.body?.baseDepartmentId)
            this.sharedDataService.organizationId = data?.body?.organisationId;
            this.userOrgService.setOrgId(data?.body?.organisationId);
            this.userOrgService.setUserId(data?.body?.staffId);
            if (data?.body?.oneSignalUserId) {
              this.userOrgService.setOneSignalUserId(data.body.oneSignalUserId);
            }
            this.sharedDataService.locationId = data?.body?.locationIds[0].locationId;
            this.sharedDataService.setPlanFormSubmitted(true)
          }
          this.dialogRef?.close('success');
          this.passwordIncorrect = false;
          addSpinnerRef.close();
          this.tokenService.saveToken(data.body.jwt);
          this.tokenService.saveRefreshToken(data.body.refreshToken);
          this.tokenService.saveStemplingEnabled(data.body.isStemplingEnabled);
          this._auth.refreshTokenInterval(
            data.body.expiryDate - Math.floor(Date.now())
          );
          const baseLocation = data?.body?.locationIds.find((loc:any) => loc.baseLocation === true);
          this.permissionsService.loadUserRoleAndPermissions(data?.body?.userRole,baseLocation.locationId).subscribe();
          this.sharedDataService.activeTab = '/dashboard';
          this.router.navigateByUrl('/dashboard');
          this.getOrgData()
        }
      },
      error: (error: any) => {
        this.passwordIncorrect = false;
        addSpinnerRef.close();
        this.loginAttempts++;
        if (this.loginAttempts >= 3) {
          cooldownEnd = Date.now() + this.cooldownTime * 1000;
          localStorage.setItem('cooldownEnd', cooldownEnd.toString());
          this.startCooldownTimer(cooldownEnd);
          this.translate
            .get('login.invalid_login.MAX_ATTEMPTS', {
              time: this.cooldownTime,
            })
            .subscribe((translatedMessage: string) => {
              this.showSnackbar(translatedMessage, 3000);
            });
        }
        localStorage.setItem('loginAttempts', this.loginAttempts.toString());
        if (this.loginAttempts >= 3) {
          this.translate
            .get('login.invalid_login.COOLDOWN_MESSAGE', {
              time: `<span class="error-time">${this.formatTime(
                this.cooldownTime
              )}</span>`,
            })
            .subscribe((translatedMessage: string) => {
              this.errorMessage = translatedMessage;
            });
          this.disableLogin = true;
        }
      },
    });
  }

  getOrgData() {
    this.orgService.fetchOrganization().subscribe({
      next: (orgData: any) => {
        if (orgData.status === 200) {
          this.sharedDataService.setOrgDetails(orgData.body);
          const logoUrl = orgData.body.logo_url
            ? `${this.envService.imgReviewUrl}/${orgData.body.logo_url}`
            : 'assets/image/no-org-logo.webp';

          this.sharedDataService.setOrgLogo(logoUrl);
        }
      },
    });
  }

  startCooldownTimer(cooldownEnd: number) {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    this.countdownSubscription = interval(1000).subscribe(() => {
      const timeLeft = Math.ceil((cooldownEnd - Date.now()) / 1000);
      if (timeLeft <= 0) {
        this.errorMessage = '';
        this.disableLogin = false;
        localStorage.removeItem('cooldownEnd');
        localStorage.setItem('loginAttempts', '0'); // Reset login attempts
        this.loginAttempts = 0;
        this.countdownSubscription?.unsubscribe();
      } else {
        this.translate
          .get('login.invalid_login.COOLDOWN_MESSAGE', {
            time: `<span class="error-time">${this.formatTime(
              timeLeft
            )}</span>`,
          })
          .subscribe((translatedMessage: string) => {
            this.errorMessage = translatedMessage;
          });
        this.disableLogin = true;
      }
    });
  }

  startOtpCooldownTimer(otpCooldownEnd: number){
     if (this.otpCountdownSubscription) {
      this.otpCountdownSubscription.unsubscribe();
    }
    this.otpCountdownSubscription = interval(1000).subscribe(() => {
      const timeLeft = Math.ceil((otpCooldownEnd - Date.now()) / 1000);
      if (timeLeft <= 0) {
        this.errorMessage = '';
        this.disableOtp = false;
        localStorage.removeItem('otpCooldownEnd');
        localStorage.setItem('otpAttempt', '0'); // Reset login attempts
        this.otpAttempt = 0;
        this.otpCountdownSubscription?.unsubscribe();
      } else {
        this.translate
          .get('login.invalid_login.COOLDOWN_MESSAGE', {
            time: `<span class="error-time">${this.formatTime(
              timeLeft
            )}</span>`,
          })
          .subscribe((translatedMessage: string) => {
            this.errorMessage = translatedMessage;
          });
        this.disableOtp = true;
      }
    });
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}s`;
  }

  showSnackbar(message: string, duration: number) {
    const snackbarOptions: any = {
      data: {
        message: message,
        icon: 'close',
        action: 'close',
        color: 'red',
      },
      panelClass: 'snackbar',
    };
    snackbarOptions['duration'] = duration;
    this.snackbarService.openFromComponent(
      CustomToastComponent,
      snackbarOptions
    );
  }
  ssoLogin() {
    this.loginForm.get('email')?.clearValidators();
    this.loginForm.get('password')?.clearValidators();
    this.loginForm.get('email')?.updateValueAndValidity();
    this.loginForm.get('password')?.updateValueAndValidity();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href =
        'https://app-01-orgapp-sn-dev-api.azurewebsites.net/sso-login/okta';
    }
  }

  requestOtp(event: Event) {
    if (this.disableOtp) {
      event.stopPropagation();
    } else {
      this.loginService.email = this.loginForm.value.email;
      this.otpReqEmail = this.loginForm.value.email;
      this.disableOtp = true
      this.otpApiCall();
    }
    this.handleOtpRequest()
  }

  handleOtpRequest(){
    let otpCooldownEnd = Number(localStorage.getItem('otpCooldownEnd')) || 0;
    this.otpAttempt++;
        if (this.otpAttempt >= 3) {
          otpCooldownEnd = Date.now() + this.cooldownTime * 1000;
          localStorage.setItem('otpCooldownEnd', otpCooldownEnd.toString());
          this.startOtpCooldownTimer(otpCooldownEnd);
          // this.translate
          //   .get('login.invalid_login.MAX_ATTEMPTS', {
          //     time: this.cooldownTime,
          //   })
          //   .subscribe((translatedMessage: string) => {
          //     this.showSnackbar(translatedMessage, 3000);
          //   });
        }
        localStorage.setItem('otpAttempt', this.otpAttempt.toString());
        if (this.otpAttempt >= 3) {
          // this.translate
          //   .get('login.invalid_login.COOLDOWN_MESSAGE', {
          //     time: `<span class="error-time">${this.formatTime(
          //       this.cooldownTime
          //     )}</span>`,
          //   })
          //   .subscribe((translatedMessage: string) => {
          //     this.errorMessage = translatedMessage;
          //   });
          this.disableOtp = true;
        }
  }

  otpApiCall(type?:string) {
    const addSpinnerRef = this.dialog.open(SpinnerComponent, {
      disableClose: true,
      panelClass: 'transparent-dialog',
    });
    this.loginService.requestOtp(this.otpReqEmail).subscribe({
      next: (data: any) => {
        if (data.status === 200) {
          addSpinnerRef.close();
          this.showLogin = false;
          if(type && type === 'forgot-pwd'){
            this.showForgotPwd = data.status;
            this.loginService.email = this.otpReqEmail;
            this.frgtPwdOtp = true
          }
          // this.router.navigateByUrl('/login/otp');
        }
      },
      error: (error: any) => {
        addSpinnerRef.close();
      },
    });
  }

  updateLoginStatus(data:any) {
    if(data?.type === 'login'){
    this.showLogin = data?.status;
    this.getEmailData()
    this.dialogRef?.updateSize('476px')
    this.frgtPwdOtp = false
    this.showForgotPwd = false
    this.changePwd = false
    }
    else if(data?.type === 'change-pwd'){
      this.changePwd = true
      this.changePwdModal()
      this.frgtPwdOtp = false
    }
    else if(data?.type === 'forgot-pwd'){
      this.frgtPwdOtp = false
      this.showForgotPwd = true
    }
  }

  changePwdModal() {
      let data = {
        showCurrPwd:false
      }
      const dialogRef = this.dialog.open(ResetPasswordComponent, {
        width: '511px',
        height: '511px',
        disableClose: true,
        panelClass: 'orgApp-change-passwrd-panel',
        data:data
      });
      dialogRef.afterClosed().subscribe((result) => {
        // Handle form data returned from dialog
        if ((result === 'success') || result?.status === 'success' && result?.type === 'login') {
          this.changePwd = false
          this.showLogin = true
          this.showForgotPwd = false
          this.dialogRef?.updateSize('476px')
        }
        else if(result?.status === 'success' && result?.type === 'back'){
          this.changePwd = false
          this.frgtPwdOtp = true
        }
      });
  }

  closeLogin(status: boolean) {
    if (status) {
      this.dialogRef?.close();
    }
  }

  getEmailData() {
    const emailValue = this.loginForm.get('email')?.value.trim();
    this.loginForm.patchValue({ email: emailValue });

    if (this.loginForm.get('email')?.valid) {
      this.disableOtp = false;
    } else {
      this.disableOtp = true;
    }
  }
  trimSpaces(field: string) {
    const control = this.loginForm.get(field);
    if (control) {
      const trimmedValue = control.value.trim();
      control.setValue(trimmedValue, { emitEvent: false });
      if (field == 'email') {
        this.getEmailData();
      }
    }
  }


  onWrapperClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Check if the click is within the country code select field
    if (target.closest('.country-code-field')) {
      // Open the mat-select dropdown
      this.countryCodeSelect.open();
    } else {
      // Focus the phone input field if clicking elsewhere
      const phoneInput = document.querySelector('.phone-input') as HTMLElement;
      phoneInput?.focus();
    }
  }

  updateValidation() {
    this.mobPlaceHolder = phoneNumberValidation(
      this.loginForm.value.countryCode
    );
    // Any additional logic, if needed, when the country code changes
  }

  onFocus() {
    if (!this.loginForm.get('email')?.hasError('invalidPhoneNumber')) {
      this.isFocused = true;
    } else {
      // this.onBlur()
    }
    this.isMobileFieldTouched = true;
  }

  onBlur() {
    this.isFocused = false;
  }
  forgotPwd() {
    this.showForgotPwd = true;
    this.showLogin = false;
    this.disableOtp = true
    this.dialogRef?.updateSize('511px')
  }

  updateFrgtPwdStatus(data: any) {
    if (data.email) {
      this.otpReqEmail = data.email;
      // this.frgtPwdOtp = true
      this.otpApiCall('forgot-pwd');
    }
    else{
      this.showLogin = !data.status
      this.showForgotPwd = false
      this.changePwd = false
      this.getEmailData()
      this.dialogRef?.updateSize('476px')
    }
  }
}